exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-page[data-v-11a3b61c]{height:calc(100vh - 64px)}", ""]);

// exports
